<template>
  <div class="bg-white w-full py-10">
    <div class="w-full mx-auto text-center">
      <graphic-base width="301" height="231" :viewBox="'0 0 301 231'">
        <LicensesRedirect />
      </graphic-base>
    </div>
    <div class="mx-auto mt-8 w-10/12 text-center">
      <span :class="textColorClass" class="text-zt-lg">
        {{ $t("message.LicensesManager.redirect.title") }}
      </span>
    </div>
    <div class="mx-auto mt-8 w-9/12 text-center">
      <span class="text-zt-dark-300 text-zt-md">
        {{ $t("message.LicensesManager.redirect.subtitle") }}
      </span>
    </div>
    <div class="mx-auto mt-8 w-full text-center">
      <zt-button @click="$router.push('/')" data-vs-button="formatedDateFrom">{{ $t("message.LicensesManager.redirect.backToHome") }}</zt-button>
    </div>
  </div>
</template>

<script>
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import LicensesRedirect from '@/components/commons/Illustrations/graphicSVG/licensesRedirect'

export default {
  components: {
    graphicBase,
    LicensesRedirect
  },
  computed: {
    isInIframe() {
      return window.self !== window.top;
    },
    textColorClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    }
  }
}
</script>

<style lang="scss" scoped>
.text-iframe-primary {
  color: #2694fc !important;
}
</style>